<template>
    <div :class="topMarginContent.class" :style="topMarginContent.style">
        <slot />
    </div>
</template>

<script lang="ts">
import { mapState } from 'pinia';
import { TopMarginResult, useNavigationStore } from '../../stores/navigation';

export default {
    props: {
        sm: { type: Number, default: 0 },
        md: { type: Number, default: 0 },
        lg: { type: Number, default: 0 },
        xl: { type: Number, default: 0 },
    },
    computed: {
        ...mapState(useNavigationStore, ['additionalTopMarginContent']),
        topMarginContent(): TopMarginResult {
            return this.additionalTopMarginContent({ prefix: 'mt', sm: this.sm, md: this.md, lg: this.lg, xl: this.xl });
        }
    },
};
</script>
